/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Videoplayer from './Videoplayer';
import Plyr from 'plyr-react';
import YouTube from 'react-youtube';
// import './YoutubePlayer.scss';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import './Video.style.css';
import 'plyr-react/dist/plyr.css';
import {
  isWebView,
  post,
  copyToClipboardHybrid,
  formatVideoUrl,
  updateUsageTrack,
  setDefaultUserAgent,
} from '../../../../Utilities';
import PlyrHlsVideoPlayer from '../PlyrHlsVideoPlayer';
import { Forward10, Pause, PlayArrow, Replay10 } from '@mui/icons-material';
import { useCreditsModal } from '../../ToastModal/ToastModal';

const NormalPlayer = ({
  sourcess,
  client_user_id,
  currentelement,
  name,
  contact,
  clientId,
  updateFinishedTime,
}) => {
  const NormalVideoRef = useRef();
  const containerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const showModal = useCreditsModal();

  const [playerprops, setplayerprops] = useState({
    options: {
      autoplay: false,
      youtube: {
        noCookie: false,
        rel: 0,
        showinfo: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playerVars: {
          origin: window.location.origin,
        },
      },
      controls: [
        'play-large',
        'rewind',
        'play',
        'fast-forward',
        'progress',
        'current-time',
        'duration',
        'settings',
      ],
    },
    source: {
      type: 'video',
      sources: [sourcess],
    },
  });

  const toggleFullscreen = () => {
    if (isFullscreen) {
      if (window.Android?.setScreenOrientation) {
        window.Android.setScreenOrientation('portrait');
      }
    } else {
      if (window.Android?.setScreenOrientation) {
        window.Android.setScreenOrientation('landscape');
      }
    }
    setIsFullscreen(!isFullscreen);
  };

  // Exit fullscreen on ESC
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && isFullscreen) {
        setIsFullscreen(false);
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => document.removeEventListener('keydown', handleEscKey);
  }, [isFullscreen]);

  // Reset loaded state and handle source changes properly
  useEffect(() => {
    setIsVideoLoaded(false);

    const formattedSource = { ...sourcess, src: formatVideoUrl(sourcess.src) };
    setplayerprops((prev) => ({
      ...prev,
      source: { type: 'video', sources: [formattedSource] },
    }));

    if (sourcess.provider === 'youtube') {
      updateUsageTrack(clientId);
    }
  }, [sourcess.src]);

  // Handle video progress tracking
  useEffect(() => {
    const playerWrapper = NormalVideoRef.current;
    if (!playerWrapper) return;

    const playerInstance = playerWrapper.plyr;
    if (!playerInstance) return;
    // Ensure seeking happens only once
    const trySeekToLastPosition = () => {
      console.log(playerInstance, 'playerInstance=========');
      if (sourcess.latest_access && sourcess.finishedTime) {
        console.log('✅ Seeking to saved position:', Number(sourcess.finishedTime));
        try {
          setTimeout(() => {
            playerInstance.currentTime = parseInt(sourcess.finishedTime);
          }, 1500);
        } catch (err) {
          console.warn('Seek failed:', err);
        }
      }
    };

    playerInstance.on('ready', () => {
      trySeekToLastPosition();
      setIsVideoLoaded(true);
    });

    // ---- Handle progress updates ----
    let lastUpdateTime = 0;
    const updateInterval = 5; // seconds between API calls

    const handleTimeUpdate = () => {
      const currentTime = playerInstance.currentTime;
      const duration = playerInstance.duration;

      // Send update every 5s or when completed
      if (currentTime - lastUpdateTime >= updateInterval || currentTime === duration) {
        lastUpdateTime = currentTime;

        if (currentTime > 1) {
          const payload = {
            section_has_file_id: sourcess.sectionFileId,
            client_user_id,
            total_time: Number(duration).toFixed(2),
            type: 'file',
            file_type: 'video',
            finished_time: Number(currentTime).toFixed(2),
          };

          console.log('Posting progress update:', payload);
          post(
            payload,
            clientId === 1104
              ? '/updateCourseContentViewStatusKaryakarta'
              : '/updateCourseContentViewStatus',
          ).then((res) => {
            if (res && res.success) {
              updateFinishedTime(sourcess, currentTime);
              if (res.result?.credits_added) {
                showModal({
                  credits: res.result?.credits || 20,
                });
              }
            }
          });
        }
      }
    };

    playerInstance.on('timeupdate', handleTimeUpdate);

    return () => {
      playerInstance.off('timeupdate', handleTimeUpdate);
      playerInstance.off('ready', trySeekToLastPosition);
    };
  }, [sourcess.src]);

  // Custom controls state
  const [isPlaying, setIsPlaying] = useState(false);
  const [playerSpeed, setPlayerSpeed] = useState(1);

  // Custom controls handlers
  const playPause = () => {
    const player = NormalVideoRef.current?.plyr;
    if (!player) return;
    if (player.playing) {
      player.pause();
      setIsPlaying(false);
    } else {
      player.play();
      setIsPlaying(true);
    }
  };

  const seek = (type) => {
    const player = NormalVideoRef.current?.plyr;
    if (!player) return;
    if (type === 'plus') {
      player.currentTime = Math.min(player.currentTime + 10, player.duration);
    } else if (type === 'minus') {
      player.currentTime = Math.max(player.currentTime - 10, 0);
    }
  };

  const changeSpeed = () => {
    const player = NormalVideoRef.current?.plyr;
    if (!player) return;
    let nextSpeed = playerSpeed + 0.25;
    if (nextSpeed > 2) nextSpeed = 0.5;
    setPlayerSpeed(nextSpeed);
    player.speed = nextSpeed;
  };

  useEffect(() => {
    const player = NormalVideoRef.current?.plyr;
    if (!player) return;
    // Sync play state
    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);
    player.on('play', onPlay);
    player.on('pause', onPause);
    return () => {
      player.off('play', onPlay);
      player.off('pause', onPause);
    };
  }, []);

  return (
    <div ref={containerRef} className={`video-container ${isFullscreen ? 'fullscreen' : ''}`}>
      {/* Loader — shown while video is not yet ready */}
      {!isVideoLoaded && (
        <div className='video-loader'>
          <div className='video-loader__spinner' />
        </div>
      )}

      {/* Player — always mounted so Plyr can initialise, but hidden until ready */}
      <div style={{ visibility: isVideoLoaded ? 'visible' : 'hidden' }}>
        <Plyr {...playerprops} ref={NormalVideoRef} />
      </div>

      {/* Custom Controls */}
      {/* <div className='custom-controls'>
        {!isFullscreen && (
          <button onClick={playPause} className='bottomDiv playPosition'>
            {isPlaying ? <Pause /> : <PlayArrow />}
          </button>
        )}
        {!isFullscreen && (
          <button onClick={() => seek('minus')} className='bottomDiv minusPosition'>
            <Replay10 />
          </button>
        )}
        {!isFullscreen && (
          <button onClick={() => seek('plus')} className='bottomDiv plusPosition'>
            <Forward10 />
          </button>
        )}
        {!isFullscreen && (
          <button onClick={changeSpeed} className='bottomDiv speedPosition'>
            <p className='mb-0 text18'>{playerSpeed}x</p>
          </button>
        )}
        <button
          style={isFullscreen ? { bottom: '0px' } : {}}
          onClick={toggleFullscreen}
          className='bottomDiv fixedWidth fullscreenPosition'
        >
          {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </button>
      </div> */}

      <button
        style={isFullscreen ? { bottom: '0px' } : {}}
        onClick={toggleFullscreen}
        className='bottomDiv fixedWidth fullscreenPosition'
      >
        {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </button>

      {isFullscreen && (
        <div
          style={{
            position: 'fixed',
            color: 'orange',
            bottom: 20,
            left: 20,
            zIndex: 9999,
          }}
        >
          <p className='mb-0'>{name}</p>
          <p>{contact}</p>
        </div>
      )}
    </div>
  );
};

const YoutubePlayer = ({
  vid,
  sourcess,
  client_user_id,
  name,
  contact,
  clientId,
  updateFinishedTime,
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const playerRef = useRef(null);
  const [videoId, setVideoId] = useState('');
  const [playerSpeed, setPlayerSpeed] = useState(1);
  const playerContainerRef = useRef(null);
  const [player, setPlayer] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const timerRef = useRef(null);
  const hasRestoredPosition = useRef(false); // Track if we've already restored position

  const syncKeepScreenAwake = (on) => {
    if (isWebView && typeof window.Android?.setKeepScreenAwake === 'function') {
      window.Android.setKeepScreenAwake(on ? 'true' : 'false');
    }
  };

  const handleFullscreen = () => {
    if (!isFullscreen) {
      if (playerContainerRef.current.requestFullscreen) {
        playerContainerRef.current.requestFullscreen();
      } else if (playerContainerRef.current.webkitRequestFullscreen) {
        playerContainerRef.current.webkitRequestFullscreen();
      } else if (playerContainerRef.current.msRequestFullscreen) {
        playerContainerRef.current.msRequestFullscreen();
      }
      setIsFullscreen(true);
      if (isWebView && typeof window.Android?.setScreenOrientation !== 'undefined') {
        window.Android.setScreenOrientation('landscape');
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      setIsFullscreen(false);
      if (isWebView && typeof window.Android?.setScreenOrientation !== 'undefined') {
        window.Android.setScreenOrientation('portrait');
      }
    }
  };

  useEffect(() => {
    if (isWebView && typeof window.Android.setDefaultUserAgent !== 'undefined') {
      window.Android.setDefaultUserAgent();
    }
  }, []);

  const trySeekToLastPosition = () => {
    if (sourcess.latest_access && sourcess.finishedTime && !hasRestoredPosition.current) {
      console.log('✅ Seeking to saved position:', Number(sourcess.finishedTime));
      try {
        playerRef.current.seekTo(parseInt(sourcess.finishedTime));
        hasRestoredPosition.current = true; // Mark as restored
      } catch (err) {
        console.warn('Seek failed:', err);
      }
    }
  };

  // Handle ready event
  const handleReady = (event) => {
    const player = event.target;
    playerRef.current = player;
    setPlayer(event.target);
    setIsReady(true);
    event.target.setVolume(100);

    // Try to seek to last position after a short delay to ensure player is fully ready
    setTimeout(() => {
      trySeekToLastPosition();
    }, 1500);
  };

  // Your existing effects
  useEffect(() => {
    updateUsageTrack(clientId);
    setVideoId(vid);
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement,
      );
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    const disableTab = (event) => {
      if (event.key === 'Tab') {
        event.preventDefault();
        window.location.reload();
      }
    };

    document.addEventListener('keydown', disableTab);

    return () => {
      document.removeEventListener('keydown', disableTab);
    };
  }, []);

  useEffect(() => {
    if (isWebView && typeof window.Android?.disableScreenshot !== 'undefined') {
      window.Android.disableScreenshot();
    }

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (player && vid) {
      player.loadVideoById(vid);
      // Reset the restoration flag when video changes
      hasRestoredPosition.current = false;
      // Try to restore position after video loads
      setTimeout(() => {
        trySeekToLastPosition();
      }, 1000);
    }
  }, [vid, player]);

  const opts = {
    playerVars: {
      modestbranding: 1,
      rel: 0,
      controls: 1,
      enablejsapi: 1,
      fs: 0,
      iv_load_policy: 3,
      origin: window.location.origin,
      autoplay: 0,
    },
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('User switched tabs');
        copyToClipboardHybrid('_', false);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [vid, player]);

  const trackProgress = () => {
    if (playerRef && playerRef.current) {
      const currentTime = playerRef.current.getCurrentTime();
      const totalTime = playerRef.current.getDuration();
      try {
        const payload = {
          section_has_file_id: sourcess.sectionFileId,
          client_user_id: client_user_id,
          total_time: Number(totalTime).toFixed(2),
          type: 'file',
          finished_time: Number(currentTime).toFixed(2),
        };

        post(payload, '/updateCourseContentViewStatus').then((res) => {
          if (res && res.success) {
            updateFinishedTime(sourcess, currentTime);
          }
        });
        console.log('Progress tracked:', currentTime);
      } catch (error) {
        console.error('Error tracking progress:', error);
      }
    }
  };

  // Handle YouTube player state changes
  const handleStateChange = (event) => {
    console.log(event, 'event');

    // When video is cued/ready (state 5), try to restore position
    if (event.data === 5 && !hasRestoredPosition.current) {
      setTimeout(() => {
        trySeekToLastPosition();
      }, 300);
    }

    if (event.data === 1) {
      // Playing
      setIsPlaying(true);
      // syncKeepScreenAwake(true);

      if (!timerRef.current) {
        timerRef.current = setInterval(trackProgress, 5000);
      }
    } else {
      // Paused, ended, buffering, etc.
      setIsPlaying(false);
      // syncKeepScreenAwake(false);
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const changeSpeed = () => {
    if (playerRef.current.getPlaybackRate() === 2) {
      playerRef.current.setPlaybackRate(0.5);
      setPlayerSpeed(0.5);
    } else {
      playerRef.current.setPlaybackRate(playerRef.current.getPlaybackRate() + 0.25);
      setPlayerSpeed(playerRef.current.getPlaybackRate() + 0.25);
    }
  };

  const playPause = () => {
    if (playerRef.current.getPlayerState() === 2) {
      playerRef.current.playVideo();
      setIsPlaying(true);
    } else {
      playerRef.current.pauseVideo();
      setIsPlaying(false);
    }
    console.log(playerRef.current);
    console.log(playerRef.current.getPlaybackQuality());
  };

  const seek = (type) => {
    if (type === 'plus') {
      playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10);
    } else if (type === 'minus') {
      playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10);
    }
  };

  useEffect(() => {
    // setDefaultUserAgent();
  }, []);

  // Cleanup timer on unmount
  useEffect(() => {
    syncKeepScreenAwake(true);
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      // release the wake lock when the user leaves the player,
      // even if the player was mid-playback
      syncKeepScreenAwake(false);
    };
  }, []);

  return (
    <>
      <div ref={playerContainerRef} className='youtubePlayerDiv position-relative'>
        <div className='topGradient' />
        {isFullscreen && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              zIndex: 100000,
              backgroundColor: 'transparent',
              pointerEvents: 'none',
            }}
          />
        )}
        <YouTube
          videoId={videoId || ''}
          ref={playerRef}
          iframeClassName={isFullscreen ? 'playerIframeFs' : 'playerIframe'}
          style={{ width: '100%' }}
          opts={opts}
          allow='accelerometer;  clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          onReady={handleReady}
          onEnd={() => {
            playerRef.current.seekTo(0);
            console.log(playerRef.current);
          }}
          onStateChange={handleStateChange}
        />

        {isReady && (
          <>
            {!isFullscreen && (
              <button onClick={playPause} className='bottomDiv playPosition'>
                {isPlaying ? <Pause /> : <PlayArrow />}
              </button>
            )}
            {!isFullscreen && (
              <button onClick={() => seek('minus')} className='bottomDiv minusPosition'>
                <Replay10 />
              </button>
            )}
            {!isFullscreen && (
              <button onClick={() => seek('plus')} className='bottomDiv plusPosition'>
                <Forward10 />
              </button>
            )}
            {!isFullscreen && (
              <button onClick={changeSpeed} className='bottomDiv speedPosition'>
                <p className='mb-0 text18'>{playerSpeed}x</p>
              </button>
            )}
            <button
              style={isFullscreen ? { bottom: '0px' } : {}}
              onClick={handleFullscreen}
              className='bottomDiv fixedWidth fullscreenPosition'
            >
              {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </button>
            {isFullscreen ? <div className='bottomStripBottom' /> : null}
          </>
        )}
        {isReady && !isFullscreen && <div className='bottomStrip' />}
        {isReady && <div className='bottomDivLeft' />}
        <div style={{ position: 'fixed', color: 'orange', bottom: 50, left: 20 }}>
          {isFullscreen && (
            <div className='font' style={{ zIndex: 9999 }}>
              <p className='mb-0'>{name}</p>
              <p className=''>{contact}</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default function VideoShow({
  drm,
  sourcess,
  normalplayer,
  youtubeplayer,
  client_user_id,
  client_id,
  history,
  file_url_hls,
  currentElement,
  updateFinishedTime,
  name,
  contact,
}) {
  const [hlsLink, setHlsLink] = useState(null);
  const [loading, setLoading] = useState();
  // let timer = useRef(null);

  useEffect(() => {
    setHlsLink(file_url_hls);
  }, [file_url_hls]);

  const videoSrc = {
    autoplay: false,
    controls: true,
    responsive: true,
    playbackRates: [0.5, 1, 1.5, 2],
    aspectRatio: '21:9',
    controlBar: {
      remainingTimeDisplay: true,
      fullscreenToggle: true,
    },
  };

  return (
    <>
      {loading ? (
        <div className='Free_Screen'>
          <i className='fa-solid fa-play'></i>
        </div>
      ) : youtubeplayer ? (
        <YoutubePlayer
          vid={sourcess.src}
          updateFinishedTime={updateFinishedTime}
          sourcess={sourcess}
          client_user_id={client_user_id}
          name={name}
          clientId={client_id}
          contact={contact}
        />
      ) : normalplayer ? (
        <NormalPlayer
          sourcess={sourcess}
          updateFinishedTime={updateFinishedTime}
          client_user_id={client_user_id}
          currentelement={currentElement}
          name={name}
          contact={contact}
          clientId={client_id}
        />
      ) : (
        <PlyrHlsVideoPlayer
          link={hlsLink}
          name={name}
          contact={contact}
          sectionFileId={sourcess.sectionFileId}
          clientUserId={client_user_id}
        />
      )}
    </>
  );
}

VideoShow.propTypes = {
  drm: PropTypes.string.isRequired,
};
